import PropTypes from 'prop-types';
import React, { Component } from "react";
import Modal from "react-bootstrap4-modal";
import { userFormValidator, inputFocusHandler } from "utils/userFormValidate";

class RedeemModal extends Component {
  render() {
    const { id, token, survey_user } = this.props.reward;
    const { confirmRedeem, handleChange } = this.props;

    function validateUserForm(event) {
      const result = userFormValidator(event, ['email']);
      if (result) confirmRedeem(id, survey_user);
    }

    return (
      <div>
        <Modal
          visible={this.props.modalToggle}
          onClickBackdrop={this.props.closeModal}
        >
          <div className="modal-header">
            <h5 className="modal-title">Redeem Coupon </h5>
            <a
              href=""
              onClick={this.props.closeModal}
              className="close-delete-popup"
            >
              X
            </a>
          </div>
          <div className="modal-body">
            <form className="form" id="userForm">
              <div className="form-group">
                <div className="input-label">Coupen Id</div>
                <input className="form-control" value={token} disabled />
              </div>
              <div className="form-group">
                <label className="input-label" id="descriptionLabel">
                  First Name*
                </label>
                <input
                  className="form-control"
                  name="first_name"
                  required
                  value={survey_user && survey_user.first_name}
                  onChange={handleChange}
                  onBlur={inputFocusHandler.bind(this)}
                  pattern="^[A-Z,a-z ,.'-]+$"
                />
                {this.props.modalToggle ? <div className="row error" id="first_nameError" /> : null}
              </div>
              <div className="form-group">
                <label className="input-label" id="descriptionLabel">
                  Middle Name
                </label>
                <input
                  className="form-control"
                  name="middle_name"
                  onChange={handleChange}
                  value={survey_user && survey_user.middle_name}
                  onBlur={inputFocusHandler.bind(this)}
                  pattern="^[A-Z,a-z ,.'-]+$"
                />
              </div>
              <div className="form-group">
                <label className="input-label" id="descriptionLabel">
                  Last Name
                </label>
                <input
                  className="form-control"
                  name="last_name"
                  value={survey_user && survey_user.last_name}
                  onChange={handleChange}
                  onBlur={inputFocusHandler.bind(this)}
                />
                <div className="row error" id="last_nameError" />
              </div>
              <div className="form-group">
                <label className="input-label">Email</label>
                <input
                  className="form-control"
                  type="email"
                  name="email"
                  onChange={handleChange}
                  value={survey_user && survey_user.email}
                  onBlur={(e) => inputFocusHandler(e, true)}
                />
              </div>
              {this.props.modalToggle ? <div className="row error" id="emailError" /> : null}
            </form>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-add-new bg-danger"
              onClick={this.props.closeModal}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-add-new"
              onClick={(e) => validateUserForm(e)}
            >
              Confirm
            </button>
          </div>
        </Modal>
      </div>
    );
  }
}

RedeemModal.propTypes = {
  reward: PropTypes.shape({
    id: PropTypes.number,
    token: PropTypes.string,
    survey_user: PropTypes.object
  }),
  confirmRedeem: PropTypes.func,
  handleChange: PropTypes.func
};

export default RedeemModal;



// WEBPACK FOOTER //
// ./src/components/redemption/RedeemModal.js